export default __webpack_public_path__ + "776e9e0e.jpg";